import React, { useEffect } from "react";
import { IconButton, Grid } from "@mui/material";
import { RiFileExcel2Fill } from "react-icons/ri";

import { useDispatch, useSelector } from "react-redux";
import { getExcelListForUpdateDate } from "../../store/actions/PlannedMaintenanceUpdateActions";

export default function UpdateDateFromExcel(props) {
    const dispatch = useDispatch();

    const { PlannedMaintenanceUpdateReducer } = useSelector((state) => state);

    useEffect(() => {
        if (PlannedMaintenanceUpdateReducer?.excelList) {
            props.callBackTabData(props.tabId, PlannedMaintenanceUpdateReducer);
        }
    }, [PlannedMaintenanceUpdateReducer]);

    const checkFile = (event) => {
        if (event.target.files && event.target.files[0]) {
            let file = event.target.files[0];
            const formData = new FormData();
            formData.append("file", file);

            props.setFormData(formData);

            let payload = {
                data: formData,
            };

            dispatch(getExcelListForUpdateDate(payload));
        }
    };

    return (
        <div>
            <IconButton
                id="udfe_IconButton"
                component="label"
                disabled={props.disableExcel}
                size="large">
                <RiFileExcel2Fill id="udfe_CreateNewFolder" style={{ width: 50, height: 50, fill: props.disableExcel ? "#bdbdbd" : "green" }} />
                <input id="udfe_input" onChange={checkFile} type="file" style={{ display: "none" }} />
            </IconButton>
        </div>
    );
}
